import { Alignment, Button, Classes, Dialog, HTMLTable, InputGroup } from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IProduto } from "../../model";
import { ProdutoStore } from "../../stores/legislacao/ProdutoStore";
import { MDBBtn } from "mdbreact";
import InfiniteScroll from "react-infinite-scroll-component";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
const numeral = require("numeral");

var debounce = require('lodash.debounce');

interface Props {
  entrada_saida: string
  value: number;
  estado: string
}

interface State { }

@observer
export class ProdutoMultiSelect extends React.Component<Props, State> {

  obs = observable({
    value: [] as IProduto[],
    isOpen: false as boolean,
    filter: "" as string,
    current_page: 1 as number,
    calc_ic: window.location.pathname.split("/")[3],
    filter_added: "" as string,
    loading: false as boolean,
    page: 1 as number,
    hasMore: true as boolean,
    options: [] as IProduto[],
    fetchOptions: {} as any
  });

  constructor(props: Props) {
    super(props);

    this.obs.fetchOptions = debounce(this.fetchOptions.bind(this), 800);

  }

  async fetchOptions(inputValue: string, page: number) {

    this.obs.loading = true;

    try {

      this.obs.filter = inputValue

      const result: any = await ProdutoStore.load(page, inputValue, this.props.entrada_saida,this.props.estado);

      if (result.length > 0) {

        this.obs.options = [...this.obs.options, ...result];
        this.obs.page = page;
        this.obs.hasMore = true

      } else {

        this.obs.hasMore = false;

      }

    } catch (error) {

      console.error('Erro ao buscar dados:', error);

    }

    this.obs.loading = false;

  }

  async handleBuscaProdutos() {

    this.obs.current_page = 1

    this.obs.filter_added = ""

    let resp = await ProdutoStore.loadCalcProdutos(1, this.obs.calc_ic, this.obs.filter_added, this.props.estado)

    this.obs.value = []
    this.obs.value = resp

  }

  handleClick = async () => {

    await this.fetchOptions("", 1);

    this.handleBuscaProdutos()

    this.obs.isOpen = true;

  };

  handleScroll = (event: any) => {

    const bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;

    if (bottom && this.obs.hasMore) {

      this.fetchOptions(this.obs.filter, this.obs.page + 1);

    }

  };

  fetchMoreAvisos = async () => {

    this.obs.current_page = this.obs.current_page + 1

    let resp = await ProdutoStore.loadCalcProdutos(this.obs.current_page, this.obs.calc_ic, this.obs.filter_added, this.props.estado)

    this.obs.value = [...this.obs.value, ...resp]

  };

  handleClose = () => {

    this.obs.isOpen = false;

  };

  handleConfirm = () => {

    this.obs.isOpen = false;

  };

  async handleRemove(item: IProduto) {

    let resp = await ProdutoStore.handleDeleteProduto(item._id, this.obs.calc_ic, this.props.estado)

    if (resp) {

      this.handleBuscaProdutos()

    }

  }

  async handleFilterProdutos(e) {

    this.obs.filter_added = e

    this.obs.current_page = 1

    let resp = await ProdutoStore.loadCalcProdutos(1, this.obs.calc_ic, e, this.props.estado)

    this.obs.value = []
    this.obs.value = resp

  }

  render() {

    let rows = this.obs.value?.map(value => {
      return (
        <tr key={value._id}>
          <td>{value.ncm}</td>
          <td>{value.cest}</td>
          <td>{value.descricao}</td>
          <td>{
            <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={this.handleRemove.bind(this, value)}
            >
              <img src="/images/bin.png" width={25} />
            </MDBBtn>
          }</td>
        </tr>
      );
    });

    const handleSelect = async (value: any, item: IProduto) => {

      let resp = await ProdutoStore.handleAddProduto(item.id, this.obs.calc_ic, this.props.estado)

      if (resp) {

        this.handleBuscaProdutos()

      }

    }

    return (
      <>
        <Button
          text={`${numeral(this.props.value).format()} produto(s) seleciondo(s)`}
          rightIcon="multi-select"
          alignText={Alignment.LEFT}
          onClick={this.handleClick}
          className="multiSelect"
        />

        <Dialog
          isOpen={this.obs.isOpen}
          title="Selecionar Produtos"
          enforceFocus={false}
          onClose={this.handleClose}
          canOutsideClickClose={false}
          style={{ width: 900 }}
        >
          <div className={Classes.DIALOG_BODY} style={{ height: 400 }}>
            <div style={{ display: "flex", alignItems: "center" }}>

              <Autocomplete
                disablePortal
                size="small"
                options={this.obs.options}
                onInputChange={(event, value) => {
                  this.obs.options = [];
                  this.obs.page = 1;
                  this.obs.hasMore = true;
                  this.obs.fetchOptions(value, 1);
                }}
                getOptionLabel={(option) => `${option.ncm} - ${option.cest} - ${option.descricao}` || ""}
                onChange={handleSelect}
                ListboxProps={{ onScroll: this.handleScroll }}
                style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Pesquisar"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {this.obs.loading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                value={null}
                className='select-empresas'
                clearOnBlur
                clearOnEscape
                blurOnSelect
                noOptionsText="Não foram encontrados resultados!"
              />

              <InputGroup
                style={{ marginLeft: 10, width: 200 }}
                placeholder="Filtrar (NCM, CEST, Descrição)"
                value={this.obs.filter_added}
                onChange={(e: any) => this.handleFilterProdutos(e.target.value)}
              />
            </div>

            <div style={{ marginTop: 15, marginBottom: 15 }}>
              {this.props.value} itens selecionado(s)
            </div>

            <InfiniteScroll
              dataLength={this.obs.value.length}
              next={this.fetchMoreAvisos}
              hasMore={true}
              height={300}
              loader={ProdutoStore.obs.loading ?
                <div style={{ textAlign: "center" }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                  </div>
                </div>
                : ""}
            >
              <HTMLTable
                className="table table-hover dataTable"
                small
              >
                <thead>
                  <tr>
                    <th style={{ width: 50 }}>NCM</th>
                    <th style={{ width: 50 }}>CEST</th>
                    <th style={{ width: 600 }}>DESCRIÇÃO</th>
                    <th style={{ width: 50 }} />
                  </tr>
                </thead>
                <tbody>
                  {rows}
                </tbody>
              </HTMLTable>
            </InfiniteScroll>

          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" onClick={this.handleConfirm} intent="primary" />
            </div>
          </div>
        </Dialog>
      </>
    );
  }
}
